<div class="full-width custom-date-filter-wrapper" fxLayoutAlign="start center"
     fxLayoutGap="15px">
  <div *ngIf="presetsShowing">
    <mat-button-toggle-group (change)="broadcastDateRange($event)"
                             [(value)]="dateOption"
                             [hideSingleSelectionIndicator]="true" [ngClass]="showBorder ? 'custom-date-button-toggle' : 'custom-borderless-button-toggle'">
      <ng-container *ngFor="let customRange of customDateRangePresets">
        <mat-button-toggle [disabled]="loading$ | async" style="height: 33px" value="{{customRange.presetId}}">
          <div fxLayout="row" fxLayoutAlign="start center">
            <div>{{ customRange.getReadableFormat() }}</div>

            <ng-container *ngIf="customRange.timeFrame == TimeFrames.BOUNDARY">
              <mat-form-field style="width: 1px; visibility: hidden; height: 0">
                <input (dateChange)="selectBoundaryDate(true, $event, customRange)" [matDatepicker]="picker" matInput>
                <mat-datepicker #picker></mat-datepicker>
              </mat-form-field>
              <mat-datepicker-toggle [class.mat-datepicker-toggle-active]="dateOption === customRange.presetId"
                                     [for]="picker"
                                     class="custom-button-date-picker custom-date-picker" matIconSuffix>
                <mat-icon matDatepickerToggleIcon>today</mat-icon>
              </mat-datepicker-toggle>
            </ng-container>
          </div>
        </mat-button-toggle>

      </ng-container>

      <mat-button-toggle [value]="'custom'" fxHide></mat-button-toggle>
    </mat-button-toggle-group>
  </div>
  <mat-form-field *ngIf="datePickerShowing"
                  [ngClass]="dateOption === 'custom' ? 'custom-date-picker-active' : 'custom-date-picker'"
                  appearance="outline" floatLabel="always">
    <mat-label *ngIf="customLabel">{{ customLabel }}</mat-label>
    <mat-date-range-input (click)="selectCustomDate(false)" [disabled]="loading$ | async" [formGroup]="range" [max]="maxDate"
                          [min]="minDate" [rangePicker]="rangePicker">
      <input [placeholder]="placeholder" formControlName="start" matStartDate/>
      <input (dateChange)="selectCustomDate(true)" formControlName="end" matEndDate/>
    </mat-date-range-input>
    <mat-datepicker-toggle [for]="rangePicker" matIconSuffix>
      <mat-icon matDatepickerToggleIcon>keyboard_arrow_down</mat-icon>
    </mat-datepicker-toggle>
    <mat-date-range-picker #rangePicker></mat-date-range-picker>

    <mat-error *ngIf="range.controls.start.hasError('matStartDateInvalid')">Invalid start date</mat-error>
    <mat-error *ngIf="range.controls.end.hasError('matEndDateInvalid')">Invalid end date</mat-error>
  </mat-form-field>

  <div *ngIf="showClearButton">
    <button (click)="clearFilters()" class="button-action-cancel" mat-flat-button>
      <div class="button-text">Clear</div>
    </button>
  </div>
</div>



